import axios from 'axios'
import { useSnackbarStore } from '@/stores/useSnackbarStore'
import { useValidationDialogStore } from '@/stores/useValidationDialogStore'

const useApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor de requisição para adicionar o Bearer token
useApi.interceptors.request.use(config => {
  const accessToken = useCookie('accessToken').value

  if (accessToken)
    config.headers.Authorization = `Bearer ${accessToken}`

  return config
}, error => {
  return Promise.reject(error)
})

// Interceptor de resposta para tratar erros
useApi.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response) {
    const { data, status } = error.response

    // Inicializar stores dentro do interceptor para evitar problemas de timing
    const snackbarStore = useSnackbarStore()
    const validationDialogStore = useValidationDialogStore()

    if (status === 401) {
      useCookie('userData').value = null
      useLocalStorage('userAbilityRules', []).value = null
      useCookie('accessToken').value = null
      window.document.location.href = '/admin/auth/login'

      snackbarStore.showSnackbar({
        text: 'Sua sessão foi encerrada por segurança. Por favor, faça login novamente.',
        color: 'error',
        timeout: 4000,
        location: 'top center',
      })

      return Promise.reject(error)
    }
    else if (status === 403) {
      snackbarStore.showSnackbar({
        text: 'Atenção: Você não possui autorização para acessar este recurso.',
        color: 'warning',
        timeout: 4000,
        location: 'top center',
      })

      return Promise.reject(error)
    }
    else if (status === 422) {
      // Trata o erro de validação 422
      const errors = data.errors || {}

      validationDialogStore.showValidationDialog(status, errors)

      snackbarStore.showSnackbar({
        text: 'Algumas informações precisam ser ajustadas. Por favor, revise os campos destacados.',
        color: 'warning',
        timeout: 4000,
        location: 'top center',
      })

      return Promise.reject(error)
    }
    else if (status >= 500) {
      snackbarStore.showSnackbar({
        text: 'Estamos enfrentando uma instabilidade momentânea. Por gentileza, tente novamente em instantes.',
        color: 'error',
        timeout: 5000,
        location: 'top center',
      })

      return Promise.reject(error)
    }
    else {
      snackbarStore.showSnackbar({
        text: error.response.data.message || 'Ocorreu um problema inesperado. Nossa equipe já foi notificada.',
        color: 'error',
        timeout: 4000,
        location: 'top center',
      })

      return Promise.reject(error)
    }
  }
})

export default useApi
